import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

// Fade + slide-up on scroll into view. `.reveal` class is force-shown in print (see index.css).
// Respects the user's "reduce motion" OS setting (renders statically, no animation).
const Reveal = function({ children, delay = 0, className = "" }) {
  const reduceMotion = useReducedMotion();

  if (reduceMotion) {
    return <div className={`reveal ${className}`}>{children}</div>;
  }

  return (
    <motion.div
      className={`reveal ${className}`}
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.5, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export default Reveal;
